import { Box } from '@mui/material';

import LetterTypeToggle, { type LetterType } from './components/LetterTypeToggle';
import PageHeader from './components/PageHeader';

export type { LetterType };

interface HeaderPaneProps {
  letterType: LetterType;
  onLetterTypeChange: (value: LetterType) => void;
}

const HeaderPane = ({ letterType, onLetterTypeChange }: HeaderPaneProps) => {
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          mb: 3,
          justifyContent: 'space-between',
        }}
      >
        <PageHeader letterType={letterType} />
      </Box>

      <LetterTypeToggle value={letterType} onChange={onLetterTypeChange} />
    </>
  );
};

export default HeaderPane;
